import { useEffect, useState } from 'react';
import { ShieldAlert, X } from 'lucide-react';

/**
 * SessionExpiredBanner — écoute l'évènement global `session:expired` (dispatché par
 * l'intercepteur axios d'AuthContext quand un endpoint /api/* renvoie 401).
 * Affiche une bannière discrète en haut de page avec un bouton "Se reconnecter"
 * plutôt que de rediriger l'utilisateur de force.
 */
export default function SessionExpiredBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = () => setVisible(true);
    window.addEventListener('session:expired', handler);
    return () => window.removeEventListener('session:expired', handler);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-amber-50 border-b border-amber-200 shadow-sm" data-testid="session-expired-banner">
      <div className="max-w-5xl mx-auto px-4 py-2.5 flex items-center gap-3">
        <ShieldAlert className="w-4 h-4 text-amber-600 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-xs font-medium text-amber-800">Session expirée</p>
          <p className="text-[11px] text-amber-700 truncate">Reconnectez-vous pour continuer à utiliser cette section.</p>
        </div>
        <a
          href="/login?expired=1"
          className="inline-flex items-center h-7 px-3 rounded-full bg-amber-600 hover:bg-amber-700 text-white text-[11px] font-medium transition-colors flex-shrink-0"
          data-testid="session-expired-login-link"
        >
          Se reconnecter
        </a>
        <button
          type="button"
          onClick={() => setVisible(false)}
          className="w-6 h-6 rounded-full text-amber-600 hover:bg-amber-100 flex items-center justify-center flex-shrink-0"
          aria-label="Fermer"
          data-testid="session-expired-close"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
